import type { Category } from 'src/stores/Category';

export const mapMiddleToSmallCategories = (categories: Category) =>
  categories.middleCategories.map((mc) => ({
    ...mc,
    smallCategories: categories.smallCategories
      .filter((sc) => mc.smallCategoryIds.includes(sc.smallCategoryId))
      .map((sc) => ({ smallCategoryId: sc.smallCategoryId, slug: sc.slug }))
  }));
